import TablePagination from '@amzn/awsui-components-react/polaris/table-pagination';
import {
  Button,
  Checkbox,
  Table,
  TableContentSelector,
  TablePreferences,
  TablePropertyFiltering,
  TableSorting,
} from 'AWS-UI-Components-React';
import React from 'react';
import { downloadFile, toDownloadFormat } from '../../../utilities';
import { getChannelMappingFilters } from './channel_mapping_utils';

const tablePageSize = 30;

const hiddenColumns = ['comments', 'ignored'];

export class ChannelMappingTable extends React.Component {

  getColumnDefinitions = () => {
    return [
      {
        id: 'cognosChannelType',
        header: this.formatHeader('Cognos Channel Type'),
        columnName: 'Cognos Channel Type',
        minWidth: '150px',
        cell: (item) => item.cognosChannelType,
      },
      {
        id: 'channelDescription',
        header: this.formatHeader('Cognos Channel Description'),
        columnName: 'Cognos Channel Description',
        minWidth: '150px',
        cell: (item) => item.channelDescription,
      },
      {
        id: 'cognosParentChannel',
        header: this.formatHeader('Cognos Parent Channel'),
        columnName: 'Cognos Parent Channel',
        minWidth: '130px',
        cell: (item) => item.cognosParentChannel,
      },
      {
        id: 'cognosChannel',
        header: this.formatHeader('Cognos Channel'),
        columnName: 'Cognos Channel',
        minWidth: '130px',
        cell: (item) => item.cognosChannel,
      },
      {
        id: 'hcpMerchantChannel',
        header: this.formatHeader('HCP Merchant Channel'),
        columnName: 'HCP Merchant Channel',
        minWidth: '130px',
        cell: (item) => item.hcpMerchantChannel,
      },
      {
        id: 'hcpChannelType',
        header: this.formatHeader('HCP Channel Type'),
        columnName: 'HCP Channel Type',
        minWidth: '130px',
        cell: (item) => item.hcpChannelType,
      },
      {
        id: 'marketplaceId',
        header: this.formatHeader('Marketplace Id'),
        columnName: 'Marketplace Id',
        cell: (item) => item.marketplaceId,
      },
      {
        id: 'marketplaceName',
        header: this.formatHeader('Marketplace Name'),
        columnName: 'Marketplace Name',
        cell: (item) => item.marketplaceName,
      },
      {
        id: 'excluded',
        header: this.formatHeader('Excluded'),
        columnName: 'Excluded',
        cell: (item) => (
          <Checkbox
            checked={item.excluded || false}
            controlId={item.id}
          />
        )
      },
      {
        id: 'ignored',
        header: this.formatHeader('Ignored'),
        columnName: 'Ignored',
        cell: (item) => (
          <Checkbox
            checked={item.ignored || false}
            controlId={item.id}
          />
        )
      },
      {
        id: 'comments',
        header: this.formatHeader('Comments'),
        columnName: 'Comments',
        cell: (item) => item.comments,
      },
    ];
  };

  formatHeader = (header) => {
    if (header.includes("Cognos")) {
      return this.formatStyle(header, "green");
    } else if (header.includes("HCP")) {
      return this.formatStyle(header, "crimson");
    } else {
      return header;
    }
  };

  formatStyle = (header, color) => {
    return <span style={{color: color}}> {header} </span>;
  };

  onClickDownloadData = (columnDefinitions, channelMappings) => {
    columnDefinitions.map((def) => def.header = def.columnName);
    const data = toDownloadFormat(columnDefinitions, channelMappings);
    downloadFile(data, 'Channel_Mappings.xls');
  };

  tableContentSelectorOptions = (columnDefinitions) => {
    return [
      {
        options: columnDefinitions.map((entry) => {
          return {
            id: entry.id,
            label: entry.columnName,
            visible: !hiddenColumns.includes(entry.id),
          };
        }),
        label: '',
      },
    ];
  };

  render() {
    const columnDefinitions = this.getColumnDefinitions();
    const { channelMappings } = this.props;

    return (
      <div>
        <Table
          columnDefinitions={ columnDefinitions }
          items={ channelMappings }
          header={
            <div className="awsui-util-action-stripe">
              <div className="awsui-util-action-stripe-title">
                <h2>Channel Mappings <span className="awsui-util-header-counter">({ channelMappings.length })</span></h2>
              </div>
              <div className="awsui-util-action-stripe-group">
                <Button
                  text="Download Data"
                  onClick={ () => this.onClickDownloadData(columnDefinitions, channelMappings) }
                  icon="download"
                  disabled={ !channelMappings.length }
                />
              </div>
            </div>
          }
          loadingText={ 'Loading channel mappings...' }
          loading={ !channelMappings.length }
          stickyHeader
        >
        <TablePropertyFiltering
          filteringOptions={getChannelMappingFilters(channelMappings)}
          groupValuesText="Values"
          groupPropertiesText="Properties"
          operationOrText="or"
          operationAndText="and"
          operationNotAndText="and not"
          operationNotOrText="or not"
          clearFiltersText="Clear filter"
          placeholder="Filter channel mappings"
          allowFreeTextFiltering={true}
        />
        <TableSorting
          sortingColumn="marketplaceId"
          sortableColumns={ [
            {id: 'cognosChannelType', field: 'cognosChannelType'},
            {id: 'cognosChannel', field: 'cognosChannel'},
            {id: 'excluded', field: 'excluded'},
            {id: 'hcpChannelType', field: 'hcpChannelType'},
            {id: 'hcpMerchantChannel', field: 'hcpMerchantChannel'},
            {id: 'marketplaceId', field: 'marketplaceId'},
            {id: 'marketplaceName', field: 'marketplaceName'},
          ] }
        />
        <TablePreferences title="Preferences" confirmLabel="Confirm" cancelLabel="Cancel">
          <TableContentSelector
            title="Select visible columns"
            options={ this.tableContentSelectorOptions(columnDefinitions) }
          />
        </TablePreferences>
        <TablePagination pageSize={ tablePageSize } />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_table.jsx